namespace GeniuzPOS.Inventory {
    export enum usefgs {
        nonuse = 0,
        usefgs = 1
    }
    Serenity.Decorators.registerEnumType(usefgs, 'GeniuzPOS.Inventory.usefgs');
}
